import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

const api = axios.create({
  baseURL: `${BACKEND_URL}/api`,
  headers: {
    'Content-Type': 'application/json'
  }
});

// Add token to requests if available
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('maintix_token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Convert FastAPI/Pydantic validation error arrays into a readable string
// so toast.error(error.response.data.detail) never receives an object/array
// (which would crash React with "Objects are not valid as a React child").
const normalizeErrorDetail = (detail) => {
  if (detail == null) return detail;
  if (typeof detail === 'string') return detail;
  if (Array.isArray(detail)) {
    return detail
      .map((d) => {
        if (typeof d === 'string') return d;
        const loc = Array.isArray(d?.loc) ? d.loc.filter((p) => p !== 'body').join('.') : '';
        const msg = d?.msg || d?.message || 'Eroare validare';
        return loc ? `${loc}: ${msg}` : msg;
      })
      .join('; ');
  }
  if (typeof detail === 'object') {
    return detail.msg || detail.message || JSON.stringify(detail);
  }
  return String(detail);
};

// Handle auth errors
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('maintix_token');
      if (window.location.pathname !== '/login') {
        window.location.href = '/login';
      }
    }
    if (error?.response?.data && 'detail' in error.response.data) {
      error.response.data.detail = normalizeErrorDetail(error.response.data.detail);
    }
    return Promise.reject(error);
  }
);

export default api;
